<template>
    <h2 class="heading">{{procure.category=='printing'?'Printing':'Procurement'}} Details</h2>
    <div class="detail" style="min-width:900px">
        <table>
            <tr><th>Request No</th> <td>{{procure.id}}</td></tr>
            <tr><th>Purpose</th> <td>{{procure.purpose}}</td></tr>
            <tr><th>Category</th> <td>{{procure.category}}</td></tr>
            <tr><th>Estimated Total Cost</th><td><span class="amount">{{global.number_format(procure.expense,2)}}</span> 
                <span class="unit">{{procure.currency}}</span></td></tr>
            <tr><th>Need by date</th> <td>{{procure.needDate}}</td></tr>
            <tr><th>Requester</th> <td>{{procure.requester}}</td></tr>
            <tr><th>Creator</th> <td>{{procure.creator}}</td></tr>
            <tr><th>Submitted at</th> <td>{{procure.createTime}}</td></tr>
            <tr><th>Status</th> <td :class="procure.status"><b>{{procure.status}}</b></td></tr>
            <tr v-if="procure.status == 'approved' || procure.status == 'rejected'"><th>Approver</th> <td>{{procure.approver}}</td></tr>
            <tr v-if="procure.status == 'approved' || procure.status == 'rejected'"><th>Reviewed at</th> <td>{{procure.approveTime}}</td></tr>
            <tr v-if="procure.comments"><th>Approver's comments</th> <td>{{procure.comments}}</td></tr>
            <tr><th>Remarks</th> <td><span style="line-height:1.6em; padding: 8px 0px;" v-html='procure.remarks2'></span></td></tr>
            <tr>
                <th>Items</th> 
                <td>
                    <template v-if="procure.category == 'printing'">
                        <table>
                            <tr><th style="min-width:200px">Item name</th>
                                <th class="center">Type</th>
                                <th class="center">Size</th>
                                <th class="center">Quantity</th>
                                <th class="center">Pages</th>
                                <th class="right">Costs (HKD)</th>
                                <th style="min-width:300px">Attachments</th>
                            </tr>
                            <tr v-for="item in printItems" :key="item">
                                <td>{{item.itemName}}</td>
                                <td class="center">{{item.printType}}</td>
                                <td class="center">{{item.printSize}}</td>
                                <td class="center">{{item.printQty}}</td>
                                <td class="center">{{item.pages}}</td>
                                <td class="right amount">{{global.number_format(item.costs, 2)}}</td>
                                <td><a v-if="item.attachments != null" href="" 
                                    @click.prevent="global.down(item.attachments.url, item.attachments.origName)">{{item.attachments.origName}}</a></td>
                            </tr>
                        </table>
                    </template>
                    <template v-else>
                        <table>
                            <tr><th style="min-width:200px">Goods name</th>
                                <th class="center">Unit Price</th>
                                <th class="center">Quantity</th>
                                <th class="right">Costs ({{procure.currency}})</th>
                                <th style="min-width:400px">Attachments</th>
                            </tr>
                            <tr v-for="item in procureItems" :key="item">
                                <td>{{item.goodsName}}</td>
                                <td class="center">{{item.unitPrice}}</td>
                                <td class="center">{{item.procureQty}}</td>
                                <td class="right amount">{{global.number_format(item.costs,2)}}</td>
                                <td>
                                    <a v-if="item.attachments != null" href="" 
                                        @click.prevent="global.down(item.attachments.url, item.attachments.origName)">{{item.attachments.origName}}</a>
                                </td>
                            </tr>
                        </table>
                    </template>
                </td>
            </tr>
            <tr v-if="procure.status == 'new' && global.hasRight('printing-procurement', 'approver')">
                <th>Approve result</th>
                <td>
                    <el-radio-group v-model="status">
                        <el-radio label="approved" class="approved"><span>Approved</span></el-radio>
                        <el-radio label="rejected" class="rejected"><span>Rejected</span></el-radio>
                    </el-radio-group>
                </td>
            </tr>
            <tr v-if="procure.status == 'new' && global.hasRight('printing-procurement', 'approver') ">
                <th>Approver's comments</th>
                <td>
                    <el-input v-model="comments" type="textarea" maxlength="500" show-word-limit="true"/>
                </td>
            </tr>
            
        </table>
        <div v-if="errMsg != ''" style="width:1024px;margin-top:15px;"><el-alert :title="errMsg" type="error" /></div>
        <div class="buttonDIV">
            <el-button v-if="procure.status == 'new' && global.hasRight('printing-procurement', 'approver')" 
                @click="approveProcurement" style="margin-right:10px;" type="primary">Submit</el-button>
            <el-button @click="backProcurmentList">Back to list</el-button>
            <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
                <img src="@/assets/loading.gif" style="height:24px;"/>
            </span>
        </div>
    </div>
</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            procure: {},
            printItems: null,
            procureItems: null,
            status: null,
            comments: '',
            errMsg: '',
            code: null,
            global,
            loading: false,
        }
    },
    computed: {
        
    },
    async mounted() {
        this.global.index = "procurement";
        this.code = this.$route.query.code;
        let result = await AXIOS("/procurement/procurementDetail", {code: this.code});
        if (result.success) {
            this.procure = result.data.procure;
            if (this.procure.category == 'printing')
                this.printItems = result.data.printItems;
            else
                this.procureItems = result.data.procureItems;
        } else {
            this.errMsg = result.errMsg;
        }
    },

    methods: {
        backProcurmentList() {
            let fromPath = sessionStorage.getItem("fromPath");
            if (fromPath && fromPath.startsWith("/procurement/")) {
                this.$router.push(fromPath);
            } else {
               if (this.global.hasRight('printing-procurement', 'approver') || this.global.hasRight('printing-procurement', 'statistician')) {
                   this.$router.push('/procurement/allProcurmentList');
               } else {
                   this.$router.push('/procurement/myProcurementList');
               }
            }
        },
        async approveProcurement() {
            this.errMsg = '';
            if (this.status == null) {
                this.errMsg = "Please select 'Approve result'";
                return;
            } else if (this.status == 'rejected') {
                if (this.comments == '') {
                    this.errMsg = "Please input 'Approver's comments'";
                    return;
                }
            }

            if (this.loading) return; //avoid repeat submit
            this.loading = true;
            let data = { code: this.code, comments: this.comments, status: this.status };
            let result = await AXIOS("/procurement/approveProcurement", data);
            if (result.success) {
                this.backProcurmentList();
            } else {
                this.errMsg = result.errMsg;
            }
        }
    }
}
</script>

<style scoped>
    .heading { width:1054px; }
    .buttonDIV { width:1000px; }
</style>